import { Component, HostListener, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common'
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router } from '@angular/router';
import { APIService } from '../fleet-management/backend-service/backend-service';
import { SharedService } from '../share-data/shared.service';
import { NotificationService } from '../shared/services/notification.service';
import { LoadingService } from '../services/loading.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../fleet-management/transport-management/confirm-dialog/confirm-dialog.component';
import { Subscription } from 'rxjs';

export interface Customer {
  id: string;
  name: string;
  address: string;
  locationPin: string;
  businessType: number;
  vatNumber: string;
  yearsInBusiness: string;
  invoiceDate: number;
  financialRating: number;
  remark: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  contactName: string;
  phoneNumber: string;
  locationLink: string;
  locations: Location[];
}

export interface Location {
  id: string;
  customerId: string;
  address: string;
  locationPin: string;
  notes: string;
  isDefault: boolean;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  contacts: Contact[];
}

export interface Contact {
  id: number;
  customerId: number;
  contactName: string;
  position: string;
  phoneNumber: string;
  email: string | null;
  isPrimary: boolean;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

@Component({
  selector: 'app-customer-management',
  imports: [
    ReactiveFormsModule,
    FormsModule,
    MatCheckboxModule,
    MatInputModule,
    CommonModule,
    MatChipsModule,
    MatSelectModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatIconModule,
    MatRadioModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './customer-management.component.html',
  styleUrl: './customer-management.component.scss'
})

export class CustomerManagementComponent implements OnDestroy {
  selectedCustomerId: string | null = null;
  dropdownPosition = { top: '0px', right: '0px' };
  searchText: string = '';
  latitude = 10.7769; // Example Latitude
  longitude = 106.7009; // Example Longitude
  currentPage: number = 1;
  totalPages: number = 1;
  pageSize: number = 10;
  pages: number[] = [];
  primaryContact: any = {};
  customer!: Customer;
  customers: Customer[] = [];
  isLoading: boolean = false;
  private loadingSubscription: Subscription;

  get googleMapsLink() {
    return `https://www.google.com/maps?q=${this.latitude},${this.longitude}`;
  }

  constructor(private router: Router, private apiService: APIService, private sharedService: SharedService,
    private notification: NotificationService,
    public loadingService: LoadingService,
    private dialog: MatDialog) {
    this.loadingSubscription = this.loadingService.isLoading$.subscribe(loading => this.isLoading = loading);
  }

  ngOnInit() {
    this.getCustomerList();
  }
  editCustomer(data: any, event: MouseEvent) {
    console.log("Selected Id: ", data.id)
    if (this.selectedCustomerId === data.id) {
      this.selectedCustomerId = null;
    } else {
      const btn = event.currentTarget as HTMLElement;
      const rect = btn.getBoundingClientRect();
      this.dropdownPosition = {
        top: `${rect.bottom + 4}px`,
        right: `${Math.max(window.innerWidth - rect.right, 8)}px`,
      };
      this.selectedCustomerId = data.id;
    }
  }
  onEdit(data: any) {
    this.selectedCustomerId = null;
    this.sharedService.setData(data);
    this.router.navigate(
      ['/home/customer-management/registration/:id'],
      { queryParams: { isEdit: true } }
    );
  }
  addNewCustomer() {
    this.router.navigate(['/home/customer-management/registration']);
  }
  getCustomerList(page: number = 1) {
    this.customers = [];
    let loginData = JSON.parse(localStorage.getItem('loginData')!)
    console.log("LoginData: ", loginData)
    this.apiService.get(`/api/customers?page=${page}&limit=${this.pageSize}`, loginData.token).subscribe({
      next: (response) => {
        console.log('/api/customer/list' + ',\n' + 'Consignee_List_Response:', response.body);
        if (response.status === 200) {
          response.body.customers.forEach((data: { [x: string]: any; }) => {
            this.primaryContact = data['contactPrimaryNumber'];
            console.log("Data_Response: ", data);
            try {
              this.customer = data as Customer;
              const firstLocation = data['locations']?.[0];
              this.customer.address = firstLocation?.address ?? '';
              this.customer.locationPin = firstLocation?.locationPin ?? '';
              this.customer.locationLink = `https://www.google.com/maps?q=${this.customer.locationPin}`;
              // if (this.customer.locations.length > 0) {
              //   for (let i = 0; i < this.customer.locations.length; i++) {
              //     if (this.customer.locations[i].isPrimary) {
              //       this.customer.contactName = this.customer.locations[i].contactName;
              //       this.customer.phoneNumber = this.customer.locations[i].phoneNumber;
              //       break;
              //     }
              //   }

              // }
              this.customers.push(this.customer);
              console.log("Customers: ", this.customers)
            } catch (error) {
              console.error('Error processing customer data:', error);
            }
          });
          this.totalPages = response.body.pagination.totalPages;
          this.pages = Array(this.totalPages).fill(0).map((_, i) => i + 1);
          this.currentPage = page;
        }
        else {
          console.log("Hey you")
        }
      },
      error: (error) => {
        console.error('Error status:', error.status);
        console.error('Error message:', error.message);
      }
    });
  }
  get filteredOrders() {
    return this.customers.filter(data =>
      data.name.toLowerCase().includes(this.searchText.toLowerCase()) ||
      // data.contactName.toLowerCase().includes(this.searchText.toLowerCase()) ||
      data.address.toLowerCase().includes(this.searchText.toLowerCase())
      // data.phoneNumber.includes(this.searchText)
    );
  }
  onDelete(data: any) {
    this.selectedCustomerId = null;
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '420px',
      data: { plateNumber: data.name, title: 'Delete Customer', confirmLabel: 'Delete', message: 'Are you sure you want to delete customer' }
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.deleteCustomer(data);
      }
    });
  }
  deleteCustomer(data: any) {
    let loginData = JSON.parse(localStorage.getItem('loginData')!)
    this.apiService.delete('/api/customers/' + data.id, loginData.token).subscribe({
      next: (response) => {
        console.log('Status:', response.status);
        console.log('/api/customers/delete' + ',\n' + 'Consignee_Delete_Response:', response);
        // if (response.status === 200) {
        //   this.customers = response.body;
        // }
        // else {
        //   console.log("Hey you")
        // }
        this.notification.success(response.message || 'Operation completed successfully');
        this.getCustomerList();
      },
      error: (error) => {
        console.error('Error status:', error.status);
        console.error('Error message:', error.message);
      }
    });
  }

  ngOnDestroy() {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
    }
  }

  // filterCustomerByPrimaryContact(customer: Customer): Customer | null {
  //   const hasPrimaryContact = customer.contacts?.some(contact => contact.isPrimary);
  //   return hasPrimaryContact ? customer : null;
  // }


  @HostListener('document:click', ['$event'])
  handleClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;

    // Only close the dropdown if clicked outside any dropdown-related button or menu
    if (!target.closest('.btn-icon-action') && !target.closest('.dropdown-menu')) {
      this.selectedCustomerId = null;
    }
  }
}
